import React, { Component } from 'react';
import Header from './header.component.js';
import EmailAddress from './emailaddress.component.js';
import styled  from 'styled-components';
import phone from '../images/phone.svg';
import vorstand from '../images/Vorstand2025.png';

const Background = styled.div`
    background-color:#f8f9fa !important; 
    border-radius:10px;
    padding: 10px;
    margin: 10px;
`;


class Board extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }
      
	render() {
    	return (
            <div>
                <div className="container opacity90">
                    <Header text="Vorstand" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Background>
                                Der Vorstand unseres Fördervereins stellt sich Euch/Ihnen vor und hofft auf zahlreiche neue Mitglieder, um unsere Kinder weiterhin bestmöglich fördern zu können!
                                <br />
                                <img className="img-fluid" src={vorstand} />
                                <br />
                                <br />
                                Stefanie Moreth - 1. Vorsitzende (2. v.l.)
                                <br />
                                <EmailAddress 
                                    classNames={""} 
                                    emailAddress={"foerderverein-bongartzstift@web.de"} 
                                    key={"stefanieMorethEmail"} 
                                />
                                <br />
                                Christian Langer - 2. Vorsitzender (1. v.r.)
                                <br />
                                <EmailAddress 
                                    classNames={""} 
                                    emailAddress={"foerderverein-bongartzstift@web.de"} 
                                    key={"christianLangerEmail"} 
                                />
                                <br />
                                Alina Spee - Kassiererin (1. v.l.)
                                <br />
                                <EmailAddress 
                                    classNames={""} 
                                    emailAddress={"foerderverein-bongartzstift@web.de"} 
                                    key={"alinaSpeeEmail"} 
                                />
                                <br />
                                <br />
                                Sollten Sie Fragen oder Anregungen haben, Mitglied werden wollen oder Spenden möchten, stehen wir alle Euch/Ihnen gerne zur Verfügung.
                            </Background>
                        </div>
                    </div>
                </div>
            </div>
    	);
  	}
}

export default Board;


// WEBPACK FOOTER //
// ./src/components/board.component.js